<template>
	<div class="tw-flex-col tw--mx-3">
		<div class="px-3 tw-pb-3">
			<c-title-header
				:title="selectedJob.name"
				@go-to-back="goTo(codeStep.returnTo)"></c-title-header>
		</div>
		<div class="tw-flex">
			<div class="px-3 tw-w-3/5">
				<model-stepper
					:current-step="9"
					class="tw-mb-4"
					@code-step="loadCodeStep">
				</model-stepper>
				<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between tw-my-">
					<div class="tw-flex tw-justify-between tw-item-center tw-mb-1">
						<p class="tw-text-app-color-primary text-lg">
							Agregar Indicadores de Resultados
						</p>
						<p-button
							type="primary"
							@click="addResults">
							Agregar Indicadores
						</p-button>
					</div>
					<div class="info tw-flex tw-item-center tw-gap-x-6 tw-mb-5">
						<img src="/static/img/enter.svg" alt="">
						<p>Presionar enter para agregar indicadores</p>
					</div>
					<section class="indicators">
						<div class="text-uppercase indicators-header tw-px-36 tw-py-1 tw-flex tw-justify-between tw-mb-4">
							<span style="width: 45%;">CALIDAD</span>
							<span>CANT.</span>
							<span>TIEMPO</span>
						</div>
						<div class="indicators-list tw-flex tw-flex-col tw-gap-3">
							<div class="tw-flex tw-gap-2" v-for="(result, index) in resultData" :key="index">
								<input
									placeholder="Calidad"
									v-model="quality[index]"
									class="indicators-input"
									style="width: 60%;"
									@input="getDataIndicators({ model: 'quality', value: $event, index: index })">
								<input
									placeholder="Cant."
									v-model="quantityPorcent[index]"
									class="indicators-input"
									style="width: 15%;"
									@input="getDataIndicators({ model: 'quantityPorcent', value: $event, index: index })">
								<v-select
									label="Tipo"
									class="select-core"
									style="width: 15%;"
									hide-details
									:menu-props="{ contentClass: 'type-select-content' }"
									height="37"
									outline
									single-line
									:items="dataDescription.times"
									item-value="id"
									item-text="name"
									return-object
									v-model="time[index]"
									@input="getDataIndicators({ model: 'time', value: $event, index: index })"
								></v-select>
								<input
									placeholder="Tiempo"
									v-model="quantity[index]"
									class="indicators-input"
									style="width: 10%;"
									@input="getDataIndicators({ model: 'quantity', value: $event, index: index })"
									@keyup.enter="handleEnterKey">
								<app-tooltip-button
									img="/static/img/close2.svg"
									text="Eliminar"
									@click-icon="deleteResult(index)"
								/>
							</div>
							<p-empty-message v-if="resultData.length === 0">
								Describe de 1 a 5 Indicadores <br>de resultados
							</p-empty-message>
						</div>
					</section>
					<div>
						<p-horizontal-divider />
						<div class="tw-text-center">
							<p-button
								type="primary"
								@click="goTo(codeStep.returnTo)"
							>
								Atrás
							</p-button>
							<p-button
							:disabled="validateEmptyFields || resultData.length < codeStep.minIndicators || resultData.length > codeStep.maxIndicators"
								type="secondary"
								@click="saveStepSeventh"
							>
								Siguiente
							</p-button>
						</div>
					</div>
				</p-card>
			</div>
			<div class="px-3 tw-w-2/5">
				<model-description
					:title="'DESTREZAS REQUERIDAS'"
					:subtitle="'INSTRUCCIONES'">
					<div class="tw-my-4" slot="content">
						<p style="font-size: 13px;" class="tw-text-center">Considere las actividades esenciales o los objetivos de trabajo 
							relacionados con los objetivos de área y escriba ¿Cómo medir su correcta ejecución?
						</p>
						<div class="content-box">
							<table>
								<tr>
									<td style="width: 25%; vertical-align: top;"><p>Ejemplo:</p></td>
									<td style="width: 75%">
										<tr>
											<td style="width: 35%;vertical-align: top;">
												<span :style="`color:${$appColors.secondary}`">Calidad</span><br>
											</td>
											<td style="width: 65%;">
												<span><b>Resolver quejas de Clientes</b></span>
											</td>
										</tr>
										<tr>
											<td style="width: 35%; vertical-align: top;">
												<span :style="`color:${$appColors.secondary}`">Cant.</span><br>
											</td>
											<td style="width: 65%;">
												<span><b>100%</b></span>
											</td>
										</tr>
										<tr>
											<td style="width: 35%; vertical-align: top;">
												<span :style="`color:${$appColors.secondary}`">Tiempo</span><br>
											</td>
											<td style="width: 65%;">
												<span><b>31 Días</b></span>
											</td>
										</tr>
									</td>
								</tr>
							</table>
						</div>
						<div class="tw-flex tw-flex-col tw-items-center">
							<br>
							<p-button
								class="tw-my-4"
								type="primary"
							>
								Mira nuestro tutorial paso a paso
							</p-button>
						</div>
					</div>
				</model-description>
			</div>
		</div>
	</div>
</template>

<script>
import cTitleHeader from '@/modules/job-profile/components/content/c-title-header';
import modelStepper from '@/modules/job-profile/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { path, pathOr } from 'ramda';

const { getLocalData } = helper;

function created() {}

async function loadData() {
	try {
		if (this.codeStep) {
			const { data: response } = await this.$httpPraktiko.get(`job-description/detail/${this.codeStep.code}/${this.selectedJob.id}`);
			if (Object.keys(response).length !== 0) {
				this.resultData = response.description;
				this.quality = response.description.map(item => item.quality);
				this.quantityPorcent = response.description.map(item => item.quantityPorcent);
				this.quantity = response.description.map(item => item.quantity);
				this.time = response.description.map(item => item.time);
				this.validateEmptyFields = this.resultData.some(item => !item.quality
					|| !item.quantityPorcent || !item.time || !item.quantity);
			}
		}
	} catch (error) {
		this.showGenericError();
	}
}

function loadCodeStep(obj) {
	this.codeStep = obj;
}

function getDataIndicators({ model, value, index }) {
	if (model === 'quality' || model === 'quantityPorcent' || model === 'quantity') {
		this[model][index] = value.target.value;
	} else if (model === 'time') {
		this[model][index] = value;
	}
	this.resultData[index][model] = this[model][index];
	this.validateEmptyFields = this.resultData.some(item => !item.quality || !item.quantityPorcent
		|| !item.time || !item.quantity);
}

function addResults() {
	this.resultData.push({
		quality: '',
		quantityPorcent: '',
		time: '',
		quantity: '',
	});
	this.validateEmptyFields = this.resultData.some(item => !item.quality || !item.quantityPorcent
		|| !item.time || !item.quantity);
}

function deleteResult(index) {
	this.resultData.splice(index, 1);
	this.quality.splice(index, 1);
	this.quantityPorcent.splice(index, 1);
	this.time.splice(index, 1);
	this.quantity.splice(index, 1);
	this.validateEmptyFields = this.resultData.some(item => !item.quality || !item.quantityPorcent
		|| !item.time || !item.quantity);
}

function handleEnterKey() {
	this.resultData.push({
		quality: '',
		quantityPorcent: '',
		time: '',
		quantity: '',
	});
	this.validateEmptyFields = this.resultData.some(item => !item.quality || !item.quantityPorcent
		|| !item.time || !item.quantity);
	if (this.resultData.length > this.codeStep.maxIndicators) {
		this.showNotification('Recuerda los resultados de deben superar los 5 items', 'warning');
	}
}

async function saveStepSeventh() {
	this.resultData = this.resultData.map((f) => {
		const newF = { ...f };
		newF.time = {
			id: f.time.id,
			code: f.time.code,
			name: f.time.name,
		};
		return newF;
	});
	const body = {
		description: this.resultData,
		typeDescriptionCode: this.codeStep.code,
		jobId: this.selectedJob.id,
		code: 'job-profile',
	};
	try {
		await this.$httpPraktiko.post('job-description', body);
		this.showNotification('Indicadores de Resultados Guardados Exitosamente');
		this.showNotification(`Descripción de Puesto de ${this.selectedJob.name} Guardados Exitosamente`);
		this.goTo(this.codeStep.goTo);
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		codeStep: {},
		quality: [],
		quantityPorcent: [],
		time: [],
		quantity: [],
		resultData: [
		],
		validateEmptyFields: true,

	};
}

export default {
	name: 'job-results-indicators',
	data,
	beforeCreate() {
		this.$store.dispatch('jobProfile/loadTimes');
		this.$store.dispatch('jobProfile/loadMeasureOfTime');
	},
	created,
	mounted() {},
	components: {
		cTitleHeader,
		modelStepper,
		PCard,
		PEmptyMessage,
		PButton,
		PHorizontalDivider,
		modelDescription,
	},
	methods: {
		loadData,
		loadCodeStep,
		getDataIndicators,
		addResults,
		deleteResult,
		handleEnterKey,
		saveStepSeventh,
	},
	computed: {
		...mapState('jobProfile', {
			selectedJob(state) {
				return pathOr(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
			},
			dataDescription: path(['descriptionData']),
		}),
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
				this.loadData();
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.info {
	border: 1px solid color(border-gray) !important;
	background-color: color(gray-light) !important;
	border-radius: 50px;
	color: color(gray-sidebar);
	font-size: size(medium);
	height: 30px !important;
	padding: 2px 10px;
	width: 50%;
}
.indicators {
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
	&-list {
		overflow: auto;
		height: 40vh;
	}
	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
        display: block;
        outline: none;
		color: color(gray-tabs) !important;
		// margin-top: 4px;
		padding: 10px 20px;
		width: auto;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}


.content-box {
	border: 1px solid color(border-gray);
	background-color: color(gray-light);
	border-radius: 5px;
	height: auto;
	width: 100%;
	padding: 10px;
	table {
		width: 100%;
		// border-collapse: collapse;
		text-align: left;
		font-size: 12px;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/seventh-page/job-results-indicators.vue